var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningGrayDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Edit-profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile-Ideal-Partner-Description",
    transform: "translate(-663.000000, -496.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(496.000000, 473.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(167.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9303579,33.4471446 L29.9357026,33.4471446 L15.9850305,5.54573757 C15.66875,5.01529185 14.9823649,4.84168343 14.4519191,5.15790101 C14.2924584,5.25297379 14.1591554,5.38627688 14.0640826,5.54573757 L0.113410507,33.4471446 C-0.151497958,33.9773388 0.0634847248,34.6218467 0.593678927,34.886818 C0.741192637,34.960512 0.903671505,34.9992454 1.06853977,35 L28.9699468,35 C29.5626425,35 30.0432882,34.5200459 30.0436026,33.9273501 C30.0436026,33.7606584 30.0048693,33.5962303 29.9303579,33.4471446 Z M16.0923018,29.6342988 C16.0923018,30.2269945 15.6118447,30.7074516 15.019149,30.7074516 C14.4264532,30.7074516 13.9459962,30.2269945 13.9459962,29.6342988 L13.9459962,28.561146 C13.9459962,27.9684502 14.4264532,27.4879931 15.019149,27.4879931 C15.6118447,27.4879931 16.0923018,27.9684502 16.0923018,28.561146 L16.0923018,29.6342988 Z M16.0923018,24.2686605 C16.0923018,24.8613562 15.6118447,25.3418133 15.019149,25.3418133 C14.4264532,25.3418133 13.9459962,24.8613562 13.9459962,24.2686605 L13.9459962,16.7567166 C13.9459962,16.1640209 14.4264532,15.6835638 15.019149,15.6835638 C15.6118447,15.6835638 16.0923018,16.1640209 16.0923018,16.7567166 L16.0923018,24.2686605 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningGrayDesktop);
export default __webpack_public_path__ + "static/media/icWarningGrayDesktop.dc4688582e974a6a418a3c40c829d96b.svg";
export { ForwardRef as ReactComponent };